import './App.scss';
import "bootstrap/dist/css/bootstrap.min.css";
import "./custom.scss"
import { Routes, Route} from 'react-router-dom';
import React, { useEffect } from "react";
import Home from './pages/home/home';
import About from './pages/about/about';
import Contact from './pages/contact/contact';
import Projects from './pages/projects/projects';
import FAQs from './pages/faqs/faqs';
import NavBar from './components/nav/navbar';
import Footer from './components/footer/footer';
import Preloader from './components/preloader/preloader';
import ErrorPage from './components/ErrorPage';

function App() {
  
    useEffect(() => {
    const noCursor = document.querySelectorAll('.btn, .form-control, .svg_black');
    noCursor.forEach(c => c.classList.add('hover-this'));
    
    const link = document.querySelectorAll('.hover-this');
    const cursor = document.querySelector('.cursor');
    const animateit = function (e) {
        if (e.type === 'mouseleave') {
            cursor.classList.remove('cursor-hover');
            cursor.classList.remove('cursor-hover2');
            cursor.classList.remove('no-cursorBg');
            link.forEach(b => b.classList.remove('zindex'));
        } else {
            if (e.target.classList.contains('btn') || e.target.classList.contains('form-control') 
                || e.target.classList.contains('svg_black') || e.target.classList.contains('svgB') ) {
              cursor.classList.add('no-cursorBg');
            } if (e.target.classList.contains('letsTalk')) {
              cursor.classList.add('cursor-hover2');
            } else {
              cursor.classList.add('cursor-hover');
            }
            link.forEach(b => b.classList.add('zindex'));
        }
    };
    const editCursor = e => {
        const { clientX: x, clientY: y } = e;
        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';
    };
    link.forEach(b => b.addEventListener('mousemove', animateit));
    link.forEach(b => b.addEventListener('mouseleave', animateit));
    window.addEventListener('mousemove', editCursor);

    return () => {
        link.forEach(b => b.removeEventListener('mousemove', animateit));
        link.forEach(b => b.removeEventListener('mouseleave', animateit));
        window.removeEventListener('mousemove', editCursor);
    };
}, []);

  return (
    
    <div >
      <Preloader />
      <NavBar />
      
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="*" element={<ErrorPage errorCode={404}/>} />
        <Route path="/500" element={<ErrorPage errorCode={500} />} />
        <Route path="/403" element={<ErrorPage errorCode={403} />} />
        <Route path="/401" element={<ErrorPage errorCode={401} />} />
        
      </Routes>

      <Footer />
      <div className="cursor"></div>
    </div>
  );
}

export default App;
